import React from "react";

const getWeatherIconUrl = (icon) => {
  // console.log("icons name-------",icon);
 return require(`../assets/weatherIocns/${icon}.png`)
};

const TempBar = ({ min, max, darkMode }) => {
  const toF = (c) => Math.round(c * 9/5 + 32);
  const minVal = toF(min);
  const maxVal = toF(max);
  return (
    <div className="flex items-center gap-1 sm:gap-1 w-auto sm:w-32">
      <span className={darkMode ? "text-base sm:text-xl font-semibold text-white" : "text-xs sm:text-sm font-semibold text-primaryBlue"}>{minVal}°</span>
      {/* <div className={
        `hidden sm:block flex-1 h-3 rounded-full relative mx-1 ` +
        (darkMode ? "bg-gradient-to-r from-blue-900 to-red-900" : "bg-gradient-to-r from-blue-400 to-red-500")
      }>
        <div
          className={
            `absolute top-0 left-0 h-3 rounded-full ` +
            (darkMode ? "bg-gradient-to-r from-yellow-400 to-red-500" : "bg-gradient-to-r from-yellow-300 to-red-500")
          }
          style={{ width: `${((maxVal - minVal) / 72) * 100}%`, minWidth: '10%' }}
        ></div>
      </div> */}
      <span className="text-xs sm:text-sm text-gray-400">/</span>
      <span className={darkMode ? "text-xs sm:text-sm font-semibold text-gray-400" : "text-xs sm:text-sm font-semibold text-primaryBlue"}>{maxVal}°</span>
    </div>
  );
};

const WeatherTables = ({ hourlyData, dailyData, darkMode }) => {
  const cardClass = darkMode
    ? "bg-blueGray border border-borderGray bg-opacity-95 rounded-xl shadow-lg p-3 sm:p-6 overflow-x-auto"
    : "bg-white bg-opacity-95 rounded-xl shadow-lg p-3 sm:p-6 overflow-x-auto";
  const thClass = darkMode
    ? "px-2 sm:px-4 py-2 text-left text-white font-semibold text-xs sm:text-sm whitespace-nowrap"
    : "px-2 sm:px-4 py-2 text-left text-gray-600 font-semibold text-xs sm:text-sm whitespace-nowrap";
  const tdClass = darkMode
    ? "px-2 sm:px-4 py-2 text-left text-white text-xs sm:text-sm whitespace-nowrap"
    : "px-2 sm:px-4 py-2 text-left text-gray-700 text-xs sm:text-sm whitespace-nowrap";
  const rowClass = darkMode
    ? "hover:bg-indigo-900 rounded-lg"
    : "bg-gray-50 hover:bg-blue-50 rounded-lg";
  const headingClass = darkMode
    ? "font-bold text-base sm:text-lg mb-4 text-white"
    : "font-bold text-base sm:text-lg mb-4 text-gray-800";

  return (
    <div className="w-full max-w-7xl flex flex-col gap-8 sm:gap-12 mb-8">
      {/* Daily Forecast Table */}
      {dailyData && dailyData.length > 0 && (
        <div className={cardClass}>
          <h3 className={headingClass}>7-Day Forecast</h3>
          <table className="min-w-full text-sm border-separate border-spacing-y-2">
            <thead>
              <tr>
                <th className={thClass}>Day</th>
                <th className={thClass}>Weather</th>
                <th className={thClass}>Temp (°F)</th>
                <th className={thClass}>Wind</th>
                <th className={thClass +  " hidden sm:table-cell"}>Precip</th>
                <th className={thClass + " hidden sm:table-cell"}>Snow</th>
              </tr>
            </thead>
            <tbody>
              {dailyData.map((d, i) => (
                <tr key={i} className={rowClass}>
                  <td className={thClass + " font-bold"}>
                    {new Date(d.dt * 1000).toLocaleDateString([], { 
                      weekday: "short", 
                      month: "short", 
                      day: "numeric" 
                    })}
                  </td>
                  <td className={tdClass + "flex-col md:flex  items-center gap-2 "}>
                    <img
                      src={getWeatherIconUrl(d.weather?.[0]?.icon)}
                      alt={d.weather?.[0]?.description || "Clear"}
                      className="w-7 h-7 sm:w-10 sm:h-10 -ml-1 sm:-ml-2"
                    
                    />
                    <span className="capitalize text-[0.6rem] sm:text-xs">
                      {d.weather?.[0]?.description || "Clear sky"}
                    </span>
                  </td>
                  <td className={tdClass}>
                    <TempBar min={d.temp.min} max={d.temp.max} darkMode={darkMode} />
                  </td>
                  <td className={tdClass}>{(d.wind_speed * 2.237).toFixed(2)} mph</td>
                  <td className={tdClass + " hidden sm:table-cell"}>{(Math.round((d.pop || 0) * 100))}%</td>
                  <td className={tdClass + " hidden sm:table-cell"}>0.0"</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Hourly Forecast Table */}
      {hourlyData && hourlyData.length > 0 && (
        <div className={cardClass}>
          <h3 className={headingClass}>24 Hours</h3>
          <table className="min-w-full text-sm border-separate border-spacing-y-2">
            <thead>
              <tr>
                <th className={thClass}>Time</th>
                <th className={thClass}>Weather</th>
                <th className={thClass}>Temp (°F)</th>
                <th className={thClass}>Wind</th>
                <th className={thClass+ " hidden sm:table-cell"}>Precip</th>
                <th className={thClass + " hidden sm:table-cell"}>Humidity</th>
              </tr>
            </thead>
            <tbody>
              {hourlyData.map((h, i) => {
                const date = new Date(h.dt * 1000);
                const isToday = date.toDateString() === new Date().toDateString();
                const isTomorrow = date.toDateString() === new Date(Date.now() + 86400000).toDateString();
                const isYesterday = date.toDateString() === new Date(Date.now() - 86400000).toDateString();
                
                let dateLabel = "";
                if (isToday) dateLabel = "Today";
                else if (isTomorrow) dateLabel = "Tomorrow";
                else if (isYesterday) dateLabel = "Yesterday";
                else dateLabel = date.toLocaleDateString([], { month: "short", day: "numeric" });
                
                return (
                  <tr key={i} className={rowClass}>
                    <td className={thClass + " font-bold"}>
                      <div className="flex flex-col">
                        <span className="text-xs sm:text-sm">
                        {date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                        </span>
                        <span  className="text-[0.6rem] sm:text-[0.65rem] opacity-75">
                        {dateLabel}
                        </span>
                      </div>
                    </td>
                  <td className={tdClass + " flex items-center gap-1 sm:gap-2"}>
                    <img
                      src={getWeatherIconUrl(h.weather?.[0]?.icon)}
                      alt={h.weather?.[0]?.description || "Clear"}
                      className="w-8 h-8 sm:w-10 sm:h-10 -ml-1 sm:-ml-2"
                      onError={(e) => {
                        e.target.src = 'https://openweathermap.org/img/wn/01d@2x.png';
                      }}
                    />
                    <span className="capitalize  text-[0.7rem] sm:text-xs">{h.weather?.[0]?.description || "Clear sky"}</span>
                  </td>
                  <td className={"px-2 sm:px-4 py-2  text-white text-base sm:text-lg whitespace-nowrap font-semibold text-center sm:text-left pl-0 sm:pl-8"}>{Math.round(h.temp * 9/5 + 32)}°</td>
                  <td className={tdClass}>{(h.wind_speed * 2.237).toFixed(2)} mph</td>
                  <td className={tdClass+ " hidden sm:table-cell"}>{Math.round((h.pop || 0) * 100)}%</td>
                  <td className={tdClass + " hidden sm:table-cell"}>{h.humidity.toFixed(2)}%</td>
                </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default WeatherTables;